export default __webpack_public_path__ + "static/media/ufma.59c30d90.png";